export default __webpack_public_path__ + "static/media/the-star@2x.068d6850.png";